import { Formik } from "formik";
import Grid from "./layout/Grid";
import Panel from "./layout/Panel";
import Row from "./layout/Row";
import Col from "./layout/Col";
import Label from "./controls/Label";
import ObjectField from "./controls/ObjectField";
import TextField from "./controls/TextField";
import {
  getTouchedFromSchema,
  isInvalid,
  touchFieldsFromErrors,
} from "../utils/forms";
import SelectField from "./controls/SelectField";
import AmmountField from "./controls/AmmountField";
import { useTranslation } from "react-i18next";
import { TanqueAcopioLiquidoSchema } from "../data/TanqueAcopioLiquidoSchema";
import Pagination from "./controls/Pagination";
import Button from "./controls/Button";

export default function TanqueAcopioLiquidoForm({
  value,
  page,
  pages,
  select,
  append,
  replace,
  remove,
  disabled,
  tiposTanque,
  unidadAltura,
  unidadAlturaLiquido,
  unidadDiametro,
  unidadVolumen,
  unidadVolumenTotal,
}) {
  const { t } = useTranslation();
  const initialTouched =
    page >= 0 ? getTouchedFromSchema(value, TanqueAcopioLiquidoSchema) : {};
  return (
    <Formik
      initialValues={value}
      enableReinitialize={true}
      validateOnChange={true}
      validateOnMount={page >= 0}
      initialTouched={initialTouched}
      validationSchema={TanqueAcopioLiquidoSchema}
      onSubmit={(values) => {
        if (page === -1) {
          append(values);
        } else {
          replace(values, page);
        }
      }}
    >
      {(form) => (
        <Grid as={<Panel />} className="formulario embebido">
          <Row>
            <Col>
              <Label>{t("tanqueAcopioLiquidoForm.titulo")}</Label>
            </Col>
          </Row>
          <Row>
            <Col>
              <ObjectField
                id="tanqueAcopioLiquido_sustanciaQuimica"
                name="sustanciaQuimica"
                value={form.values?.sustanciaQuimica}
                onChange={(event) => form.handleChange(event)}
                disabled={disabled}
              >
                {({ value, setProperty, disabled }) => (
                  <Grid>
                    <Row>
                      <Col>
                        <TextField
                          id="tanqueAcopioLiquido_sustancaiQuimica_nombreComercial"
                          name="sustanciaQuimica.nombreComercial"
                          label={t("liquidoAcopiado.nombreComercial")}
                          value={value?.nombreComercial}
                          onChange={(event) => {
                            event.preventDefault();
                            setProperty("nombreComercial", event.target.value);
                          }}
                          isInvalid={isInvalid(
                            "sustanciaQuimica.nombreComercial",
                            form,
                          )}
                          error={t(
                            form.errors.sustanciaQuimica?.nombreComercial,
                          )}
                          disabled={disabled}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={4}>
                        <TextField
                          id="tanqueAcopioLiquido_sustanciaQuimica_CAS"
                          name="sustanciaQuimica.CAS"
                          label={t("liquidoAcopiado.CAS")}
                          value={value?.CAS}
                          onChange={(event) => {
                            event.preventDefault();
                            setProperty("CAS", event.target.value);
                          }}
                          isInvalid={isInvalid("sustanciaQuimica.CAS", form)}
                          error={t(form.errors.sustanciaQuimica?.CAS)}
                          disabled={disabled}
                        />
                      </Col>
                    </Row>
                  </Grid>
                )}
              </ObjectField>
            </Col>
          </Row>
          <Row>
            <Col>
              <SelectField
                id="tanqueAcopioLiquido_clasificacion"
                name="clasificacion"
                label={t("tanqueAcopioLiquido.clasificacion")}
                value={form.values?.clasificacion}
                onChange={(event) => form.handleChange(event)}
                options={tiposTanque}
                labelAttr="nombre"
                valueAttr="codigo"
                emptyLabel="..."
                isInvalid={isInvalid("clasificacion", form)}
                error={t(form.errors.clasificacion)}
                disabled={disabled}
              />
            </Col>
          </Row>
          <Row>
            <Col lg={4}>
              <AmmountField
                id="tanqueAcopioLiquido_altura"
                name="altura"
                label={t("tanqueAcopioLiquido.altura")}
                value={form.values?.altura}
                onChange={(event) => form.handleChange(event)}
                unit={unidadAltura}
                isInvalid={isInvalid("altura", form)}
                error={t(form.errors.altura)}
                disabled={disabled}
              />
            </Col>
            <Col lg={4}>
              <AmmountField
                id="tanqueAcopioLiquido_alturaLiquido"
                name="alturaLiquido"
                label={t("tanqueAcopioLiquido.alturaLiquido")}
                value={form.values?.alturaLiquido}
                onChange={(event) => form.handleChange(event)}
                unit={unidadAltura}
                isInvalid={isInvalid("alturaLiquido", form)}
                error={t(form.errors.alturaLiquido)}
                disabled={disabled}
              />
            </Col>
            <Col lg={4}>
              <AmmountField
                id="tanqueAcopioLiquido_diametro"
                name="diametro"
                label={t("tanqueAcopioLiquido.diametro")}
                value={form.values?.diametro}
                onChange={(event) => form.handleChange(event)}
                unit={unidadDiametro}
                isInvalid={isInvalid("diametro", form)}
                error={t(form.errors.diametro)}
                disabled={disabled}
              />
            </Col>
          </Row>
          <Row>
            <Col lg={4}>
              <AmmountField
                id="tanqueAcopioLiquido_volumenOperacional"
                name="volumenOperacional"
                label={t("tanqueAcopioLiquido.volumenOperacional")}
                value={form.values?.volumenOperacional}
                onChange={(event) => form.handleChange(event)}
                unit={unidadVolumen}
                isInvalid={isInvalid("volumenOperacional", form)}
                error={t(form.errors.volumenOperacional)}
                disabled={disabled}
              />
            </Col>
            <Col lg={4}>
              <AmmountField
                id="tanqueAcopioLiquido_volumenTotal"
                name="volumenTotal"
                label={t("tanqueAcopioLiquido.volumenTotal")}
                value={form.values?.volumenTotal}
                onChange={(event) => form.handleChange(event)}
                unit={unidadVolumen}
                isInvalid={isInvalid("volumenTotal", form)}
                error={t(form.errors.volumenTotal)}
                disabled={disabled}
              />
            </Col>
          </Row>
          <Row style={{ display: "flex", flexWrap: "wrap" }}>
            <Col lg={7}>
              <Pagination
                sm
                page={page}
                pages={pages}
                onChange={(event) => select(event.target.value)}
              />
            </Col>
            <Col lg={5}>
              <span
                style={{
                  float: "right",
                  alignContent: "center",
                }}
              >
                {page !== -1 && (
                  <Button
                    sm
                    variant="success"
                    value={t("tanqueAcopioLiquidoForm.nuevo")}
                    onClick={(event) => {
                      event.preventDefault();
                      select(-1);
                    }}
                    disabled={disabled}
                  />
                )}
                {page !== -1 && (
                  <Button
                    sm
                    variant="danger"
                    value={t("tanqueAcopioLiquidoForm.eliminar")}
                    onClick={(event) => {
                      event.preventDefault();
                      remove(page);
                    }}
                    disabled={disabled}
                  />
                )}
                <Button
                  sm
                  variant="primary"
                  value={t("tanqueAcopioLiquidoForm.guardar")}
                  onClick={(event) => {
                    event.preventDefault();
                    form.validateForm().then((errors) => {
                      if (touchFieldsFromErrors(errors, form)) {
                        return;
                      }
                      form.submitForm();
                    });
                  }}
                  disabled={disabled}
                />
                {page === -1 && pages > 0 && (
                  <Button
                    sm
                    variant="default"
                    value={t("tanqueAcopioLiquidoForm.cancelar")}
                    onClick={(event) => {
                      event.preventDefault();
                      select(0);
                    }}
                    disabled={disabled}
                  />
                )}
              </span>
            </Col>
          </Row>
        </Grid>
      )}
    </Formik>
  );
}
